<template>
  <transition name="fade">
    <div class="modal" v-if="page" v-show="visible">
      <div class="modal__wrap">
        <div class="modal__title">
          ส่ง e-card ให้ครอบครัว หรือเพื่อนของคุณ
        </div>
        <div class="modal__body">
          <div class="modal__content">
            <a href="#" class="modal__close" @click.prevent="close"><i class="fas fa-times fa-lg"></i></a>
            <send-email-form v-model="emails" ref="emailForm" />
          </div>
        </div>
        <div class="modal__footer">
          <div class="text-center">
            <button class="btn btn--inline btn--white" @click.prevent="close">ยกเลิก</button>
            <button class="btn btn--inline btn--purple" @click.prevent="submit">ส่งอีการ์ด</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import SendEmailForm from '@/components/SendEmailForm'

  export default {
    name: 'ShareEmailPopup',

    components: {
      SendEmailForm
    },

    props: {
      page: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        emails: [''],
        visible: false
      }
    },

    methods: {
      open () {
        this.visible = true
      },

      close () {
        this.visible = false
      },

      submit () {
        if (!this.$refs.emailForm.validate()) {
          return
        }

        this.$modal.show({
          title: 'โปรดรอสักครู่',
          text: 'กำลังส่งอีเมล...',
          okButton: false
        })

        const emails = {}
        this.emails.forEach(email => {
          emails[email.trim()] = true
        })
        const payload = { emails: Object.keys(emails) }

        this.$http.post(`pages/${this.page.id}/share-email`, payload).then(resp => {
          this.$modal.show({
            title: 'สำเร็จ',
            text: 'ส่งอีเมลสำเร็จ'
          })
          this.close()
          this.emails = []
        }).catch(e => {
          console.log(e)
          this.$modal.show({
            title: 'เกิดข้อผิดพลาด',
            text: `ไม่สามารถส่งอีเมลได้`
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ShareEmailPopup.vue?b15b8564